// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"styles_buttonsContainer__3J90X","colorizedLoading":"styles_colorizedLoading__1LsWI"};